import React, { useState } from "react";
import styled from "styled-components";

import Chat from "./chat";
import Queue from "./queue";
import Head from "./room-head";

import { Col, Row, Box, Img, Text } from "../../../comps";
import { PLAYER_CONTROLS, ELECTRON_HEAD } from "../../../theme/dimensions";

const getXPercent = (x) => {
  return (
    (x * (window.innerHeight - PLAYER_CONTROLS.HEIGHT - ELECTRON_HEAD.HEIGHT)) /
      100 +
    "px"
  );
};

const Container = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.BLACK_3};
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.color.GRAY_2};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.GRAY_1};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb:hover {
  }
`;

const BackgroundImage = styled(Img)`
  position: absolute;
  width: 100%;
  /* sum of all heights to match Content height */
  height: ${getXPercent(132)};
  top: 0;
  left: 0;
  -webkit-filter: blur(50px);
  -moz-filter: blur(50px);
  -o-filter: blur(50px);
  -ms-filter: blur(50px);
  filter: blur(40px);
  opacity: 0.5;
`;

const Content = styled(Col)`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  align-items: center;
  overflow-y: hidden;
  overflow-x: hidden;
  padding-left: 30px;
  padding-right: 30px;
  color: white;
`;

const HeadWrapper = styled(Box)`
  width: 100%;
  height: ${getXPercent(30)};
  margin-top: ${getXPercent(2)};
`;

const SelectorWrapper = styled(Row)`
  width: 100%;
  height: ${getXPercent(6)};
  margin-top: ${getXPercent(4)};
`;

const Bottom = styled(Row)`
  width: 100%;
  height: ${getXPercent(80)};
  justify-content: space-between;
  margin-top: ${getXPercent(4)};
  margin-bottom: ${getXPercent(20)};
`;

const ChatWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const QueueWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const Option = styled(Row)`
  width: 50%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: ${({ selected, theme }) =>
    theme.color.BLUE_3 + (selected ? "ff" : "21")};
  cursor: pointer;
`;

const CONTENT_TYPE = { QUEUE: 0, CHAT: 1 };

const Selector = ({ contentType, setContentType }) => {
  return (
    <SelectorWrapper>
      <Option
        selected={contentType === CONTENT_TYPE.QUEUE}
        onClick={() => {
          setContentType(CONTENT_TYPE.QUEUE);
        }}
      >
        <Text fontSize="14px" fontWeight={600}>{`QUEUE`}</Text>
      </Option>
      <Option
        selected={contentType === CONTENT_TYPE.CHAT}
        onClick={() => {
          setContentType(CONTENT_TYPE.CHAT);
        }}
      >
        <Text fontSize="14px" fontWeight={600}>{`CHAT`}</Text>
      </Option>
    </SelectorWrapper>
  );
};

export default ({ roomInfo, refresh }) => {
  console.log("rendering mobile vie");
  const [contentType, setContentType] = useState(CONTENT_TYPE.QUEUE);
  const { members, id, thumbnail } = roomInfo || {};
  return (
    <Container>
      {thumbnail && <BackgroundImage src={thumbnail} />}
      <Content>
        <HeadWrapper>
          <Head roomInfo={roomInfo} refresh={refresh} />
        </HeadWrapper>
        <Selector contentType={contentType} setContentType={setContentType} />
        <Bottom>
          {contentType === CONTENT_TYPE.QUEUE && (
            <QueueWrapper>
              <Queue
                roomInfo={roomInfo}
                refresh={refresh}
                time={new Date().getTime()}
              />
            </QueueWrapper>
          )}
          {contentType === CONTENT_TYPE.CHAT && (
            <ChatWrapper>
              <Chat
                roomInfo={roomInfo}
                refresh={refresh}
                members={members}
                roomId={id}
              />
            </ChatWrapper>
          )}
        </Bottom>
      </Content>
    </Container>
  );
};
